var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0973 8.34598C15.298 8.13324 15.5713 8.00933 15.8591 8.0005C16.0823 7.99372 16.3023 8.05654 16.4903 8.18074C16.6782 8.30494 16.8253 8.48472 16.9124 8.69651C16.9994 8.90831 17.0223 9.14224 16.978 9.36765C16.9337 9.59307 16.8243 9.79945 16.6642 9.95975L11.1238 15.6659C10.916 15.8798 10.6342 16 10.3403 16C10.0465 16 9.76468 15.8798 9.55687 15.6659L7.34069 13.3834C7.23434 13.2783 7.14944 13.1523 7.09095 13.0129C7.03246 12.8736 7.00156 12.7236 7.00006 12.5717C6.99856 12.4199 7.02649 12.2693 7.08221 12.1287C7.13794 11.9881 7.22034 11.8604 7.32458 11.7531C7.42883 11.6457 7.55283 11.5608 7.68932 11.5035C7.82582 11.4461 7.97205 11.4173 8.11948 11.4188C8.2669 11.4204 8.41254 11.4522 8.54787 11.5125C8.6832 11.5727 8.80549 11.6601 8.9076 11.7697L10.3403 13.2452L15.0973 8.34598Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.23177c9c112a9d7ef7cf45bcdc464025.svg";
export { ForwardRef as ReactComponent };